import {useState, useEffect, useContext} from 'react'
import Validation from './Validation'
import useFetch from './useFetch'
import {ThemeContext} from '../Helper/Context'

const Signin = ({hidePopup}) => {
    const {setShowSignin, mainState, setMainState,setShowLoader} = useContext(ThemeContext);
    const [{response}, dofetch] = useFetch();
    const [apiName, setApiName] = useState(null)
    const params = new URLSearchParams(window.location.search);
    const [values, setValues] = useState({
        email:{
            value:params ? params.get("email") : '',
            required: true,
            type:'email'
        },
    })
    const [errors, setErrors] = useState (true)
    const [emailExist, setEmailExist] = useState (true);
    
    const handleChange = (e) =>{
        setValues(prevState =>({
            ...prevState,
            [e.target.name]:{
                ...prevState[e.target.name], value:e.target.value
            }
        }))
    }
    const handleChooseAnotherEmail = e =>{
        setEmailExist(true)
        setErrors(true);
    }


    const handleFormSubmit = (e) =>{
        e.preventDefault();
        setErrors(Validation(values));
    }


    const sendOneTimeCodeSMS = (memberID)=>{

        console.log('OneTimeCode api');
        setApiName('sendOneTimeCodeSMS');
        let body = "{\"memberId\": "+memberID+",\"codeDestination\": \"Sms\"}";
        // let body = "{\"memberId\": "+memberID+",\"codeDestination\": \"Email\"}";
        dofetch(mainState.fetchURL, 'SendOneTimeCode', 'SendOneTimeCode.post.odata','', body);

        
        // let myHeaders = new Headers();
        // myHeaders.append("Content-Type", "application/json");
        // myHeaders.append("Cookie", "CMSPreferredCulture=en-AU");

        // // memberID = 552266;
        // let raw = JSON.stringify({
        //     "integrationcode": "PERFECTGYMAPI",
        //     "endpointname": "SendOneTimeCode",
        //     "internalcall": "SendOneTimeCode.post.odata",
        //     "useheadervariables": true,
        //     "body": "{\"memberId\": "+memberID+",\"codeDestination\": \"Email\"}"
        // });

        // let requestOptions = {
        // method: 'POST',
        // headers: myHeaders,
        // body: raw,
        // redirect: 'follow'
        // };

        // fetch(mainState.fetchURL, requestOptions)
        // .then(response => response.json())
        // .then(result => {
        //     setShowLoader(false);
        //     console.log('OneTimeCode');
        //     console.log(result);
        //     if(result.error){
        //         alert(result.errors[0].message)
        //     }else{
        //         setShowSignin(false)
        //         setMainState(prevState=>({
        //             ...prevState,
        //             ...prevState.showVerification,showVerification:true,
        //         }))
        //     }

        // })
        // .catch(error => console.log('error', error));
    }

    
    
    const fetchUser = e =>{
        
        // setShowLoader(true);
        console.log('Get user info api');
        setApiName('getUserInfo');
        let urlParams = "?$filter=email eq '"+values.email.value+"' and isDeleted eq false&$expand=paymentSources,address";
        dofetch(mainState.fetchURL, 'GetMembers', 'info.get.odata', urlParams, '');
        // let myHeaders = new Headers();
        // myHeaders.append("Content-Type", "application/json");
        // myHeaders.append("Cookie", "CMSPreferredCulture=en-AU");

        // let bodyData = JSON.stringify({
        //     "integrationcode": "PERFECTGYMAPI",
        //     "endpointname": "GetMembers",
        //     "internalcall": "info.get.odata",
        //     "useheadervariables": true,
        //     "urlparams": "?$filter=email eq '"+values.email.value+"' and isDeleted eq false",
        //     "body": ""
        // });

        // let requestOptions = {
        // method: 'POST',
        // headers: myHeaders,
        // body: bodyData,
        // redirect: 'follow'
        // };

        // fetch(mainState.fetchURL, requestOptions)
        // .then(response => response.json())
        // .then(result => {
        //     console.log('Get user info');
        //     console.log(result.value)
        //     if(result.value.length < 1){
        //         setEmailExist(false)
        //         setShowLoader(false);
        //     }else{
        //         sendOneTimeCodeSMS(result.value[0].id);
        //         setMainState(prevState=>({
        //             ...prevState,
        //             user:{
        //                 ...prevState.user,
        //                     userId:result.value[0].id,
        //                     newUser:false,
        //                     firstName:result.value[0].firstName,
        //                     lastName:result.value[0].lastName,
        //                     email:result.value[0].email,
        //                     sex:result.value[0].sex,
        //                     birthdate:result.value[0].birthdate,
        //                     phoneNumber:result.value[0].number
        //             }
        //         }))
        //     }            
        // })
    }

    useEffect(()=>{
        if(response){
            if(apiName === 'getUserInfo'){
                console.log(response);
                if(response.value.length < 1){
                    setEmailExist(false)
                    setShowLoader(false);
                }else{
                    sendOneTimeCodeSMS(response.value[0].id);
                    setMainState(prevState=>({
                        ...prevState,
                        user:{
                            ...prevState.user,
                                userId:response.value[0].id,
                                newUser:false,
                                firstName:response.value[0].firstName,
                                lastName:response.value[0].lastName,
                                email:response.value[0].email,
                                sex:response.value[0].sex,
                                birthdate:response.value[0].birthdate,
                                phoneNumber:response.value[0].phoneNumber,
                                address:response.value[0].address,
                                paymentSources:response.value[0].paymentSources
                        }
                    }))
                }  
            }

            if(apiName === 'sendOneTimeCodeSMS'){
                setShowLoader(false);
                console.log(response);
                if(response.error){
                    alert(response.errors[0].message)
                }else{
                    setShowSignin(false)
                    setMainState(prevState=>({
                        ...prevState,
                        ...prevState.showVerification,showVerification:true,
                    }))
                }
            }
             
        }
    },[response, apiName])

    useEffect(() => {
        if(!errors){
            fetchUser();
            // alert('email exist')
            // setMainState({...mainState, showVerification:true})
            // setShowSignin(false);
            // setEmailExist(false)
            
        }
    },[errors]);

    return (
        <div className="perfectgym-popup" onClick={e=>{hidePopup(e)}}>
            <div className="popup-content">
            <div className="closebtn" onClick={(e) => setShowSignin(false)}><i className="fal fa-times"></i></div>
                {emailExist &&
                <>
                <h2>Verify Your Email Address:</h2>
                <div className="form-wrapper">
                    {/* <div className={`form-row ${errors.email ? 'Error' : ''}`}> */}
                    <div className="form-row">
                        <input 
                        type="text" 
                        name="email"
                        placeholder="Type your email address"
                        value={values.email.value}
                        onChange={handleChange}
                        />
                        {errors.email && <span className="Error">Invalid email</span>}
                    </div>
                </div>
                <button className="btn btn-right" onClick={(e) => handleFormSubmit(e)}>Verify</button>
                </>
                }

                {!emailExist &&
                <>
                <h2>Verify Your Email Address</h2>
                <p>We couldn’t find your email address in our system, please sign up, it will take around 5 mins.</p>
                <div className="linkwrapper">
                    <span className="link" onClick={(e) => handleChooseAnotherEmail(e)}><strong>Choose another email</strong></span>
                    <button className="btn btn-right" onClick={e => setMainState({...mainState,section:'signup'})}>Sign up</button>
                </div>
                </>
                }
            </div>
        </div>
    )
}
export default Signin
